import getPageCustomizableHeaderProps from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderProps';

import useMembershipsHeaderControls from '../useMembershipsHeaderControls';

const useMembershipsHeaderProps = ({ appPageConfig, programme }) => {
  const { controls } = useMembershipsHeaderControls({
    appPageConfig,
    programme,
  });

  const headerProps = getPageCustomizableHeaderProps({
    appPageConfig,
    controls,
  });

  return { ...headerProps, alignment: '10columns' };
};

export default useMembershipsHeaderProps;
